import React from 'react';
import HeaderNavigation from './components/HeaderNavigation';
import { View, Pressable, Text } from 'react-native';
//replace this logo when jpg received
import logo from './logo.avif';
import styled from 'styled-components/native';
import { Link } from 'app/src/utils/routing';
import secrets from 'app/secrets';

const HeaderContainer = styled(View)`
  height: 78px;
  padding: 10px;
  background-color: #D9D9D9;
  display: flex;
  z-index: 999999;

  flex-direction: row;
  justify-content: space-between;
  padding-right: 30px;
  @media (max-width: 480px) {
    padding-left: 5%;
    padding-right: 5%;

    > img {
      width: 90%;
    }
  }
`;

const LogoContainer = styled(View)`
  display: flex;
  flex-direction: row;
  position: relative;
`;

const EnvironmentMark = styled(Text)`
  position: absolute;
  left: 140px;
  top: 0px;
  color: #00000060;
  font-size: 46px;
  font-weight: 900;
`;

const logoStyle = {
  height: '100%'
}

const Header = (isLoggedIn) => {
  const { baseUri } = secrets.api;
  let env = '';
  if (baseUri.includes('uat') || baseUri.includes('pti-dev')) {
    env = 'UAT';
  } else if (baseUri.includes('localhost')) {
    env = 'DEV';
  }

  return (
    <HeaderContainer>
      <LogoContainer>
        <Link to={`/`}>
          <img src={logo} alt="Equiplinc Seller Portal" style={logoStyle} />
          <EnvironmentMark>{env}</EnvironmentMark>
        </Link>
      </LogoContainer>
      {isLoggedIn ? (
        <HeaderNavigation />
      ) : null
      }
    </HeaderContainer>
  )
}

export default Header;
